import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-3463">
      <Navbar data-id="element-3464" />
      <main data-id="element-3465">
        <ConsularAffairs data-id="element-3466" />
      </main>
      <Footer data-id="element-3467" />
      <FeedbackPopup data-id="element-3468" />
    </div>;
}